import {
  faCalendarStar,
  faExclamationCircle,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export function ErrorFallback() {
  return (
    <div className="flex gap-1 items-center justify-center px-2 py-1.5 rounded-md bg-neutrals-N200 text-neutrals-N900 h-10">
      <FontAwesomeIcon icon={faCalendarStar} />
      <FontAwesomeIcon
        icon={faExclamationCircle}
        className="text-primary-red-R500"
      />
    </div>
  );
}
